/** Domena nije hardkodirana — ARHITEKTURA.md sekcija 16. */
export const API_URL: string = import.meta.env.VITE_API_URL ?? 'http://localhost:8787';

/**
 * Javni sajt. Portal na njega vodi iz podnožja izbornika — klijent koji dođe
 * ravno na app adresu inače nema nijedan put natrag na cjenik, FAQ ili kontakt.
 */
export const SITE_URL: string = (
  import.meta.env.VITE_SITE_URL ?? 'https://soul-training-web-staging.pages.dev'
).replace(/\/$/, '');

/**
 * MOCK PREKIDAČ — namjerno OPT-IN.
 *
 * Portal može ići kroz `src/mocks/fetch.ts` umjesto pravog API-ja (isti
 * `createClient`, drugi `fetchImpl`). To se uključuje isključivo izričitim
 * `VITE_USE_MOCKS=true`.
 *
 * Zašto opt-in a ne opt-out: mockovi nose demo račune s poznatim lozinkama i
 * `hasActiveAccess: true` za svakoga. Kad je zadana vrijednost bila „uključeno",
 * produkcijski build (koji ne postavlja nijednu VITE_ varijablu) isporučio bi
 * javno dostupnu admin prijavu. Zaboravljena varijabla sad znači „pravi API",
 * što je u najgorem slučaju slomljen demo, a ne otvoren portal.
 *
 * Dodatna brana: u produkcijskom buildu se ne uključuju ni na izričit zahtjev.
 */
export const USE_MOCKS: boolean =
  import.meta.env.VITE_USE_MOCKS === 'true' && import.meta.env.MODE !== 'production';

/**
 * `browser` (zadano) ili `hash`. Hash se koristi samo za statične preglede
 * gdje ne postoji SPA fallback na server strani.
 */
export const ROUTER_MODE: 'browser' | 'hash' =
  import.meta.env.VITE_ROUTER === 'hash' ? 'hash' : 'browser';
